/* Opens / closes the full-screen image pop-ups rendered by snippets/sm_guide-popup-buttons.liquid.
   One delegated listener, so it keeps working when the theme editor re-renders a section.
   Esc and focus return are handled by the native <dialog>. */
(() => {
  if (window.smGuidePopupInit) return;
  window.smGuidePopupInit = true;

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-guide-popup-open]');
    if (opener) {
      const dialog = document.getElementById(opener.getAttribute('aria-controls'));
      if (dialog && !dialog.open) dialog.showModal();
      return;
    }

    const closer = event.target.closest('[data-guide-popup-close]');
    if (closer) {
      closer.closest('dialog')?.close();
      return;
    }

    // A click on the dialog itself (anywhere but the image or the close button) closes it.
    if (event.target.matches('dialog.guide-popup[open]')) event.target.close();
  });

  // When a pop-up closes, focus returns to its button and the pointer is often still over it (or
  // :hover is stale from before the dialog opened), so the button keeps its hover colours. Hold
  // hover off until the pointer is genuinely off the button: the first move clears it straight
  // away if the pointer is elsewhere, otherwise it clears when the pointer leaves the button.
  document.addEventListener('close', (event) => {
    const dialog = event.target;
    if (!(dialog instanceof HTMLDialogElement) || !dialog.classList.contains('guide-popup')) return;
    const opener = document.querySelector(`[data-guide-popup-open][aria-controls="${CSS.escape(dialog.id)}"]`);
    if (!opener) return;

    opener.setAttribute('data-gp-hover-off', '');
    const release = () => {
      opener.removeAttribute('data-gp-hover-off');
      document.removeEventListener('pointermove', onMove, true);
      opener.removeEventListener('pointerleave', release);
    };
    const onMove = (moveEvent) => {
      document.removeEventListener('pointermove', onMove, true);
      if (!opener.contains(document.elementFromPoint(moveEvent.clientX, moveEvent.clientY))) release();
    };
    document.addEventListener('pointermove', onMove, true);
    opener.addEventListener('pointerleave', release);
  }, true);
})();
